export { default } from "./ClinicalHistoryViewer";
